import { SaveNewRepChecklist } from "../new-rep-checklist-interfaces/save-new-rep-checklist.interface";

export class NewRepChecklistModel {

    private onboarding_id!: number;
    private checklist!: SaveNewRepChecklist[];

    constructor() { }

    // Getters & Setters
    getonboarding_id(): number {
        return this.onboarding_id;
    }
    setonboarding_id(onboarding_id: number) {
        this.onboarding_id = onboarding_id;
    }

    getChecklist() {
        return this.checklist;
    }

    setChecklist(data: SaveNewRepChecklist[]) {
        this.checklist = data;
    }

    toString() {
        return JSON.stringify({
            onboarding_id: this.getonboarding_id(),
            checklist: this.getChecklist(),
        });
    }
}
